'use client' // Error components must be Client Components
import { ErrorPage } from '@/components/error-page'

export default function Error({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  console.error(error)
  const errorCode =
    error.message.includes('404') ||
    error.message.includes('Not Found') ||
    error.message.includes('Server Components') // TODO: 좋지 못한 패턴
      ? 404
      : 500
  return <ErrorPage code={errorCode} reset={reset} />
}
